export var ClientViews;
(function (ClientViews) {
    ClientViews[ClientViews["Start"] = 0] = "Start";
    ClientViews[ClientViews["NewReport_Start"] = 1] = "NewReport_Start";
    ClientViews[ClientViews["NewReport_Order"] = 2] = "NewReport_Order";
    ClientViews[ClientViews["NewReport_Done"] = 3] = "NewReport_Done";
    ClientViews[ClientViews["Reports"] = 4] = "Reports";
    ClientViews[ClientViews["ReadReport"] = 5] = "ReadReport";
    ClientViews[ClientViews["ReadGroupReport"] = 6] = "ReadGroupReport";
    ClientViews[ClientViews["MyAccount_Settings"] = 7] = "MyAccount_Settings";
    ClientViews[ClientViews["MyAccount_Contracts"] = 8] = "MyAccount_Contracts";
    ClientViews[ClientViews["Sub_Companies"] = 9] = "Sub_Companies";
    ClientViews[ClientViews["Faq"] = 10] = "Faq";
})(ClientViews || (ClientViews = {}));
